<template>
    <div id="edicionMenuTop" class="edicion_menu ">
         <nav class="edicion_top_nav" style="padding-top:8px;">
             <div class="d-flex justify-content-between">
                   <ul v-if="editor" class="etn_menu" >
                    <li @click="$bus.$emit('toggleMobileEditor',false)" :style="showDesignButtons ? 'width:100% !important;text-align:center;' : 'width:100% !important;text-align:left;'">
                           <span style="margin-right:2px;text-align:right;">{{$t('filtros.ocultar')}}</span> <Icon icon="ph:caret-down-light" style="font-size: 18px; vertical-align: middle;" />
                       </li>
                       <template v-if="showDesignButtons">
                           <li
                             v-for="tab in sidebarTabs"
                             :key="tab.id"
                             class="manito"
                             :class="{ active: currentCompDesign === tab.id }"
                             :style="tabStyle(tab.id)"
                             @click="switchComponentRightDesign(tab.id)"
                           >
                               <span style="text-align:center;">{{ $t(tab.labelKey) }}</span>
                           </li>
                       </template>
                   </ul>
                   <ul v-else class="etn_menu ">
                       <li @click="$bus.$emit('toggleMobileEditor',true)" :style="showDesignButtons ? 'width:100% !important;text-align:center;' : 'width:100% !important;text-align:left;'">
                        <span style="margin-right:2px;text-align:right;">{{$t('filtros.mostrar')}}</span> <Icon icon="ph:caret-up-light" style="font-size: 18px; vertical-align: middle;" />
                       </li>
                       <template v-if="showDesignButtons">
                           <li
                             v-for="tab in sidebarTabs"
                             :key="tab.id"
                             class="manito"
                             :class="{ active: currentCompDesign === tab.id }"
                             :style="tabStyle(tab.id)"
                             @click="switchComponentRightDesign(tab.id)"
                           >
                               <span style="text-align:center;">{{ $t(tab.labelKey) }}</span>
                           </li>
                       </template>
                   </ul>
             </div>
         </nav>
   </div>
   </template>
   
   <script>
   import { getSidebarTabs, DEFAULT_SIDEBAR_TAB, TAB_MIS_DISENOS } from '@features/editor/background/sidebarTabs'

   export default {
       data() {
           return {
               editor:true,
               currentCompDesign: DEFAULT_SIDEBAR_TAB,
               showDesignButtons: true,
               sidebarTabs: getSidebarTabs(),
           }
       },
       created(){
           this.showDesignButtons = this.$store.state.sobreComp !== 'leftColSettings';
   
           this.$bus.$on('sobreCompChanged', (value) => {
               this.showDesignButtons = value !== 'leftColSettings';
           });
   
           this.$bus.$on('toggleMobileEditor', state => {
               this.editor=state
           });

           this.$bus.$on('switchComponentRightDesign', comp => {
               this.currentCompDesign = comp;
           });
   
       },
       watch: {
           '$store.state.sobreComp': {
               handler(newValue) {
                   this.showDesignButtons = newValue !== 'leftColSettings';
               },
               deep: true,
               immediate: true
           }
       },
       methods:{
           tabStyle(tabId) {
               const isLast = tabId === TAB_MIS_DISENOS;
               return `width:100% !important;text-align:center;float:right;${isLast ? '' : 'border-right: solid 1px #ddd;'}`;
           },
           switchComponentRightDesign(comp) {
               this.currentCompDesign=comp
               this.$bus.$emit('switchComponentRightDesign', comp)
           },
       },    
   }
   
   </script>
   
   
   <style scoped>
   .edicion_top_nav{
       padding-top:0px !important;
   }
   .edicion_top_nav .etn_menu > li{
       border:0px;
   }
   .etn_menu .active .etn_hide,
   .etn_menu .active a .svg{
       color: white !important;
   }
   
   .etn_menu li.active,
     .etn_menu li:active,
     .etn_menu li.pressed {
       background: #686868 !important;
       color: #ededed !important;
     }
     
     .etn_menu li.active span,
     .etn_menu li:active span,
     .etn_menu li.pressed span {
       color: #ededed !important;
     }
   </style>
